var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelevision = function SvgTelevision(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.792,
    height: 55.745
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M64.058 0H4.734A4.746 4.746 0 0 0 0 4.748v33.2a4.746 4.746 0 0 0 4.734 4.75H33.21v7.116H17.791a1.186 1.186 0 0 0-1.191 1.187v3.558a1.186 1.186 0 1 0 2.372 0v-2.372h30.843v2.372a1.186 1.186 0 1 0 2.372 0v-3.558A1.186 1.186 0 0 0 51 49.815H35.582v-7.117h28.476a4.746 4.746 0 0 0 4.734-4.75v-33.2A4.746 4.746 0 0 0 64.058 0m2.362 37.948a2.37 2.37 0 0 1-2.362 2.375H4.734a2.37 2.37 0 0 1-2.362-2.375v-33.2a2.37 2.37 0 0 1 2.362-2.375h59.324a2.37 2.37 0 0 1 2.362 2.375z",
    "data-name": "Path 48"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M13.885 6.277a1.186 1.186 0 0 0-1.677 0L8.649 9.84a1.186 1.186 0 1 0 1.677 1.677l3.558-3.558a1.186 1.186 0 0 0 .001-1.682",
    "data-name": "Path 49"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M22.794 7.463a1.186 1.186 0 0 0-1.677 0L8.649 19.931a1.186 1.186 0 1 0 1.677 1.677L22.794 9.14a1.186 1.186 0 0 0 0-1.677",
    "data-name": "Path 50"
  })))));
};
export default SvgTelevision;